import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axios from "axios";
import { ICarGroup, IProduct, ReactQueryKey } from "../../types";

interface IGetCarGroupsByLocationParams {
    pickupLocation: string,
    dropoffLocation: string,
    requestDate: string,
    pickupDate: string,
    dropoffDate: string,
    products: IProduct[]
    tenant: string,
    dealer: string
}

interface IGetCarGroupsByLocationReturn {
    carGroups: ICarGroup[]
}

export const getCarGroupsByLocation = async (params: IGetCarGroupsByLocationParams): Promise<IGetCarGroupsByLocationReturn> => {
    const response = await axios.post('/booking/instool/cargroups', params);
    return response.data;
};

export const useCarGroupsByLocationsQuery = <TSelectData = IGetCarGroupsByLocationReturn>(
    params: Partial<IGetCarGroupsByLocationParams>,
    options?: UseQueryOptions<IGetCarGroupsByLocationReturn | null, unknown, TSelectData>
) => {
    return useQuery<IGetCarGroupsByLocationReturn | null, unknown, TSelectData>(
        [ReactQueryKey.CarGroupsByLocation, params],
        () => {
            if (
                !params.pickupLocation ||
                !params.dropoffLocation ||
                !params.pickupDate ||
                !params.dropoffDate ||
                !params.products ||
                !params.tenant ||
                !params.dealer
            ) {
                return null;
            }

            return getCarGroupsByLocation({
                pickupLocation: params.pickupLocation,
                dropoffLocation: params.dropoffLocation,
                //@ts-ignore
                requestDate: params.requestDate,
                pickupDate: params.pickupDate,
                dropoffDate: params.dropoffDate,
                products: params.products,
                tenant: params.tenant as string,
                dealer: params.dealer as string
            });
        },
        options
    )
};